import { render, staticRenderFns } from "./input-area.vue?vue&type=template&id=4c1b9e54&"
import script from "./input-area.vue?vue&type=script&lang=js&"
export * from "./input-area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports